import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TransitionService } from "@uirouter/core";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";

@Injectable()
export class AccountService {
  private propsCache: Observable<any>;

  constructor(
    private http: HttpClient,
    private $transitions: TransitionService,
  ) {
    this.$transitions.onStart({}, () => {
      this.propsCache = null;
    });
  }

  public properties() {
    const url = "/api/v4/account-properties";

    if (!this.propsCache) {
      this.propsCache = this.http.get(url).pipe(shareReplay(1));
    }

    return this.propsCache;
  }
}
